<template>
    <div class="panel-content">
        <h2>Marktleider</h2>
        <p>Marktleider in de productie van medische isotopen, met de reactor leveren wij wereldwijd voor meer dan 30.000 patienten per dag aan medische isotopen.</p>
        <div class="video-container">
            <video controls src="/static/videos/overlay1-3_video.mp4"></video>
        </div>
    </div>
</template>

<style lang="scss" scoped>

</style>

<script>
    export default {

    };
</script>
